<template>
	<div class="text-wrap d-flex py-4 px-3 justify-content-between">
		<div class="card-content">
			<div v-if="type == 'abn_acn'" class="dropdown">
				<div class="dropdown__header" @click="toggleDropdown($event)">
				<h5>ABN ACN</h5>
				<ul>
					<li>
								<span class="title">Company Name:</span>
								<span class="sub-title">{{cardData.company_name}}</span>
						</li>

						<li>
								<span class="title">ABN/ACN:</span>
								<span class="sub-title">{{cardData.abn_acn}}</span>
						</li>
						<li class="margin_top">
							<span class="title">Email:</span>
							<span class="sub-title">{{cardData.mail_address}}</span>
						</li>
				</ul>
				</div>
				 <div class="dropdown__content">
				<ul>
						<li>
							<span class="title">Website:</span>
							<span class="sub-title">{{cardData.website}}</span>
						</li>
						<li>
							<span class="title">Contact:</span>
							<span class="sub-title">{{cardData.phone}}</span>
						</li>

				</ul>
				 </div>
			</div>

			<div v-if="type == 'entity_details'" class="dropdown">
				<div class="dropdown__header" @click="toggleDropdown($event)">
				<h5>Entity Details</h5>
                <ul>

					<li>
							 <span class ="title"> Entity Name:</span>
							 <span calss="sub-title">{{cardData.abn_acn_info.entity_name}}</span>
						</li>
						<li>
							<span class="title">ABN Status:</span>
							<span class="sub-title">{{cardData.abn_acn_info.abn_status}}</span>
						</li>
						<li class="margin_top">
							<span class="title">Entity Type:</span>
							<span class="sub-title">{{cardData.abn_acn_info.entity_type}}</span>
						</li>


				</ul>
				</div>
				 <div class="dropdown__content">
				<ul>
						<li>
							<span class="title">Business Location:</span>
							<span class="sub-title">{{cardData.abn_acn_info.main_business_location}}</span>
						</li>
						<li>
							<span class="title">ABN Last Updated:</span>
							<span class="sub-title">{{cardData.abn_acn_info.abn_last_updated}}</span>
						</li>
						<li>
							<span class="title">Record Extracted:</span>
							<span class="sub-title">{{cardData.abn_acn_info.record_extracted}}</span>
						</li>
						<li>
							<span class="title">GST Effective From:</span>
							<span class="sub-title">{{cardData.abn_acn_info.gst}}</span>
						</li>


				</ul>
				 </div>
			</div>

			<div v-if="type == 'license'" class="contractor-licence">
				<div class = "dropdown">
				<div class = "dropdown__header" @click="toggleDropdown($event)">
				<h5>Contractor Licence</h5>
				<div
					v-for="(license, index) in cardData.license"
					:key="index">
						<ul>

								<li v-if="license.licence_type && index < 1" class="margin_top">
									<span>
                                        <span class="title">Type:</span>
									<span class="sub-title">
										<span v-if="license.licence_type == 'trade_work'">Trade Work</span>
										<span v-if="license.licence_type == 'security'">Master Licence</span>
										<span v-if="license.licence_type == 'asbestos_and_high_risk'">Asbestos & High Risk</span>
										<span v-if="license.licence_type == 'pesticide'">Pesticide licence and permit</span>
										<span v-if="license.licence_type == 'fire_and_safety'">FPAA Accreditation</span>
										<span v-if="license.licence_type == 'other'">Other</span>
									</span>
                                    </span>
								</li>
						</ul>
					</div>
				</div>
				<div class="dropdown__content">

                        <div class="" v-for="(license, index) in cardData.license" :key="index">
                            <ul>
                            <li v-if="license.licence_type && index >= 1" >
									<span>
                                        <span class="title">Type:</span>
									<span class="sub-title">
										<span v-if="license.licence_type == 'trade_work'">Trade Work</span>
										<span v-if="license.licence_type == 'security'">Master Licence</span>
										<span v-if="license.licence_type == 'asbestos_and_high_risk'">Asbestos & High Risk</span>
										<span v-if="license.licence_type == 'pesticide'">Pesticide licence and permit</span>
										<span v-if="license.licence_type == 'fire_and_safety'">FPAA Accreditation</span>
										<span v-if="license.licence_type == 'other'">Other</span>
									</span>
                                    </span>
								</li>

                            <li  v-if="license.licence_number">
										<span class="title">Licence No.:</span>
										<span class="sub-title">{{ license.licence_number }}</span>
								</li>

								<li v-if="license.licence_status == 'verified' && license.start_date">
										<span class="title">Start Date:</span>
										<span class="sub-title">{{ momentDate(license.start_date) }}</span>
								</li>
                        </ul>
						<ul v-if="license.licence_status == 'verified' && license.expiry_date">
								<li>
										<span class="title">Expiry Date:</span>
										<span class="sub-title"> {{ momentDate(license.expiry_date) }}</span>
								</li>
						</ul>
						<ul style="margin-top: 15px; margin-bottom: 15px;">
							<li>
								<b-button @click="licensemedia()" >Licence Files</b-button>

							</li>
						</ul>
                        </div>


				</div>
				</div>
			</div>

			<div v-if="type == 'insurance'" class="dropdown">
				<div class="dropdown__header" @click="toggleDropdown($event)">
				<h5>Business Insurance</h5>
				<div
					v-for="(insurance, index) in cardData.insurances"
					:key="index"
                    class="margin_top"
				>
					<ul class="margin_top" v-if="index < 1" >
						<li>
							<span class="title">Type:</span>
							<span class="sub-title">
								<span v-if="insurance.insurance_type == 'public-liability'">Public Liability</span>
								<span v-if="insurance.insurance_type == 'workers-compensation'">Workers Compensation</span>
								<span v-if="insurance.insurance_type == 'professional-indemnity'">Professional Indemnity</span>
								<span v-if="insurance.insurance_type == 'other-insurances'">Other Insurance</span>
							</span>
						</li>


					</ul>
				</div>
				</div>
                <div class="dropdown__content">
                    <div
					v-for="(insurance, index) in cardData.insurances"
					:key="index"

				>
					<ul>
                        <li v-if="index >= 1">
							<span class="title">Type:</span>
							<span class="sub-title">
								<span v-if="insurance.insurance_type == 'public-liability'">Public Liability</span>
								<span v-if="insurance.insurance_type == 'workers-compensation'">Workers Compensation</span>
								<span v-if="insurance.insurance_type == 'professional-indemnity'">Professional Indemnity</span>
								<span v-if="insurance.insurance_type == 'other-insurances'">Other Insurance</span>
							</span>
						</li>
                        <li>
							<span class="title">Limit($): </span>
							<span class="sub-title">{{ insurance.insurance_limit.toLocaleString() }}</span>
						</li>

						<li v-if="insurance.insurance_status == 'verified' && insurance.insurer">
							<span class="title">Insurer:</span>
							<span class="sub-title">{{ insurance.insurer }}</span>
						</li>
						<li v-if="insurance.insurance_status == 'verified' && insurance.insurance_start">
							<span class="title">Start:</span>
							<span class="sub-title">
								<span v-if="insurance.insurance_start">
									{{ momentDate(insurance.insurance_start) }}
								</span>
							</span>
						</li>

						<li>
							<span class="title">Expiry: </span>
							<span class="sub-title">
								<span v-if="insurance.insurance_expiry">
									{{ momentDate(insurance.insurance_expiry) }}
								</span>
							</span>
						</li>
						<li style="margin-top: 15px; margin-bottom: 15px; ">
						<b-button @click="insurnacemedia()" >Insurance Files</b-button>

						</li>
					</ul>
				</div>
                </div>
			</div>
		</div>

		<div
			v-if="type == 'entity_details'"
		>
			<SvgIcons
				v-if="cardData.abn_acn_status == 'verified'"
				icon="icon-verified"
				width="45"
				height="55"
				svgClass="mb-1  pull-right"
			/>

			<SvgIcons
				v-else
				icon="icon-error"
				width="45"
				height="55"
				svgClass="mb-1 pull-right"
			/>
		</div>

		<div
			v-if="type == 'abn_acn'"
		>
			<SvgIcons
				v-if="cardData.abn_acn_status == 'verified'"
				icon="icon-verified"
				width="45"
				height="55"
				svgClass="mb-1  pull-right"
			/>

			<SvgIcons
				v-else
				icon="icon-error"
				width="45"
				height="55"
				svgClass="mb-1 pull-right"
			/>
		</div>

		<div
			v-if="type == 'license'"
		>
			<SvgIcons
				v-if="isAllLicensesVerified"
				icon="icon-verified"
				width="45"
				height="55"
				svgClass="mb-1  pull-right"
			/>

			<SvgIcons
				v-else
				icon="icon-error"
				width="45"
				height="55"
				svgClass="mb-1 pull-right"
			/>
		</div>

		<div
			v-if="type == 'insurance'"
		>
			<SvgIcons
				v-if="isAllInsuranceVerified"
				icon="icon-verified"
				width="45"
				height="55"
				svgClass="mb-1  pull-right"
			/>

			<SvgIcons
				v-else
				icon="icon-error"
				width="45"
				height="55"
				svgClass="mb-1 pull-right"
			/>
		</div>
	</div>
</template>

<script>
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";
import moment from "moment";

export default {

	props: {
		type: String,
		cardData: Object,
	},
	components: {
		SvgIcons,
		moment,
	},
	computed: {
		isAllLicensesVerified() {
			let verified = true;

			if (this.cardData.license.length <= 0) {
				verified = false;
			}
			this.cardData.license.forEach((data) => {
				if (data.licence_status != "verified") {
					verified = false;
				}
				//   //return verified = verified && (data.licence_status == 'verified');
			});
			return verified;
		},
		isAllInsuranceVerified() {
			let verified = true;
			this.cardData.insurances.forEach((data) => {
				if (data.insurance_status != "verified") {
					verified = false;
				}
				//   //return verified = verified && (data.licence_status == 'verified');
			});
			return verified;
		},
		licensemedia() {
			let fileLink = document.createElement('a');
        fileLink.href = this.$root.serverBasePath + '/contractor/compliance/' + this.$route.params.id + '/licencemedia';
        fileLink.setAttribute('download', 'download');
        document.body.appendChild(fileLink);
        fileLink.click();
		},
		insurnacemedia() {
			let fileLink = document.createElement('a');
        fileLink.href = this.$root.serverBasePath + '/contractor/compliance/' + this.$route.params.id + '/insurnacemedia';
        fileLink.setAttribute('download', 'download');
        document.body.appendChild(fileLink);
        fileLink.click();
		},
	},
	methods: {
		handleDocumentInfoClick() {
			this.$router.push({
				name: "contractor-compliance-sub-page",
				params: { subPage: this.type },
			});
		},
		momentDate: function (date) {
			return moment(date).format("D MMM YYYY");
		},
		toggleDropdown (event) {
                event.currentTarget.classList.toggle('is-active')
            }
	},
};
</script>

<style scoped>
.card-content ul li {
		list-style: none;
		font-size: 13px;
}

.card-content ul li span.sub-title {
		margin-left: 10px;
}

</style>
<style lang="scss">
    .dropdown {
        &__header {
            cursor: pointer;
            line-height: 50px;
            position: relative;
            text-overflow: ellipsis;
            i.fa {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                transition: opacity .3s;
                &.fa-angle-up {
                    opacity: 0;
                }
            }
            &.is-active {
                i.fa {
                    &.fa-angle-up {
                        opacity: 1;
                    }
                    &.fa-angle-down {
                        opacity: 0;
                    }
                }
                + .dropdown__content {
                    height: auto;
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
        &__content {
            height: 0;
            opacity: 0;
            overflow: hidden;
            transition: opacity .3s;
            visibility: hidden;
        }
    }

	.margin_top{
		margin-top: -15px;
		margin-bottom: -15px;
	}
</style>
